import { render, staticRenderFns } from "./register-partner.vue?vue&type=template&id=4bc7b8fc"
import script from "./register-partner.vue?vue&type=script&lang=js"
export * from "./register-partner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports